<template>
    <div class="navigation" v-if="currentStep && completed">
        <nav>
            <ul>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_1"
                            @click="changeStep(1)"
                            :class="{'active' : currentStep == 1, 'done' : completed.step_1 }">
                        <span class="circle">
                            <span class="number">1.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Welcome</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_2"
                            @click="changeStep(2)"
                            :class="{'active' : currentStep == 2, 'done' : completed.step_2 }">
                        <span class="circle">
                            <span class="number">2.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Your Details</span>
                    </button>
                </li>
                <li>
                    <button class="nav-step"
                            :disabled="!completed.step_3"
                            @click="changeStep(3)"
                            :class="{'active' : currentStep == 3, 'done' : completed.step_3 }">
                        <span class="circle">
                            <span class="number">3.</span>
                            <svg class="checkmark"><use xlink:href="#checkmark"></use></svg>
                        </span>
                        <span class="text">Billing</span>
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {

    data(){
        return {
            currentStep: null,
            completed: null,
        }
    },

    created(){
        eventBus.$on('step-change', data => {
            this.completed = data.completed
            this.currentStep = data.step
        })
    },

    methods:{
        changeStep(step){
            eventBus.$emit('change-nav-step', step)
        }
    }
}
</script>